import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CapitalizePipe } from '../../pipes/capitalize.pipe';
import { NavbarComponent } from '../../components/navbar/navbar.component';
import { FooterComponent } from '../../components/footer/footer.component';
import { RouterModule } from '@angular/router';
import { PrimaryButtonComponent } from '../components/primary-button/primary-button.component';
import { InputOrderFinderComponent } from '../components/input-order-finder/input-order-finder.component';
import { ContactFloatingButtonComponent } from '../components/contact-floating-button/contact-floating-button.component';
import { OrderStepComponent } from '../components/order-step/order-step.component';
import { PaginatorComponent } from '../components/paginator/paginator.component';
import { MapComponent } from '../components/map/map.component';



@NgModule({
  declarations: [
    NavbarComponent,
    FooterComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    CapitalizePipe,
    RouterModule,
    PrimaryButtonComponent,
    InputOrderFinderComponent,
    ContactFloatingButtonComponent,
    OrderStepComponent,
    PaginatorComponent,
    MapComponent
  ],
  exports: [
    CommonModule, 
    FormsModule, 
    CapitalizePipe,
    NavbarComponent,
    FooterComponent,
    RouterModule,
    PrimaryButtonComponent,
    InputOrderFinderComponent,
    ContactFloatingButtonComponent,
    OrderStepComponent,
    PaginatorComponent,
    MapComponent
  ]
})
export class SharedModule { }
